module.exports = __webpack_public_path__ + "img/drthumm_prisma_elemente-06.9dbbdbb2.png";